import {
  LOAN_APPLICATION_FETCH_SUCCESS,
  LOAN_APPLICATION_UPDATE_SUCCESS,
  UPDATE_FINANCIALS_SUCCESS,
  UPDATE_INCOME_SUCCESS,
  LOAN_APPLICATION_USER_GOTO_SUCCESS,
  LOAN_APPLICATION_USER_GOBACK_SUCCESS,
} from './../actions/types'

const creditSenseReport = (state={}, {type, payload}) => {
  switch(type) {
    case LOAN_APPLICATION_FETCH_SUCCESS:
      return payload.applicationFlow.creditSenseReport || state

    case LOAN_APPLICATION_UPDATE_SUCCESS:
    case UPDATE_FINANCIALS_SUCCESS:
    case UPDATE_INCOME_SUCCESS:
    case LOAN_APPLICATION_USER_GOTO_SUCCESS:
    case LOAN_APPLICATION_USER_GOBACK_SUCCESS:
      return payload.creditSenseReport || state

    default:
      return state
  }
}

export const getCreditSenseStatus = (state) => (state.enabled)
export const getCreditSenseReference = (state) => (state.reference)

export default creditSenseReport;
